// Card frames: the border on the player card above the team (client/hud.ts renderPlayerCard). Looks only.
//
// Two families that never compete: the season pass frame (worn while the pass runs, public/frames/pass.png) and the
// ranked frames (earned at Gold in a ranked season, shared/ranked.ts, kept for good in TrainerDTO.frames). One
// "Frame" choice on the player screen's Card panel lists every frame the trainer owns. With no choice made, the card
// wears the pass frame while the pass runs, exactly as before ranked frames existed.
import type { TrainerDTO } from './protocol.ts';
import { passActive } from './pass.ts';

export interface Frame { id: string; name: string; source: 'pass' | 'ranked'; season?: number }

export const FRAMES: Frame[] = [
  { id: 'pass', name: 'Season pass', source: 'pass' },
  { id: 'ranked-s1', name: 'Laurel (ranked season 1)', source: 'ranked', season: 1 },
];
export const FRAME: Record<string, Frame> = Object.fromEntries(FRAMES.map((f) => [f.id, f]));

type Holder = Pick<TrainerDTO, 'pass' | 'frames' | 'frame'>;

/** Whether the trainer may wear a frame now: the pass frame while the pass runs, a ranked one once earned. */
export function ownsFrame(t: Holder, id: string, now: number): boolean {
  const f = FRAME[id];
  if (!f) return false;
  return f.source === 'pass' ? passActive(t, now) : !!t.frames?.includes(id);
}

/** The frames the trainer owns now, in list order. */
export const ownedFrames = (t: Holder, now: number) => FRAMES.filter((f) => ownsFrame(t, f.id, now));

/** The frame the card wears: the chosen one while owned, none when 'none' is chosen, else the pass frame while it runs. */
export function frameOf(t: Holder, now: number): string | null {
  if (t.frame === 'none') return null;
  if (t.frame && ownsFrame(t, t.frame, now)) return t.frame;
  return passActive(t, now) ? 'pass' : null;
}
